<template>
    <div class="ship-popup">
      <div class="cesium-popup-header flex justify-between align-center">
        <span>水位站信息</span>
        <ElButton circle size="small" @click="props.close">X</ElButton>
      </div>
      <table v-if="properties">
        <tbody>
          <tr v-for="item in tableData" :key="item.key">
            <td class="text-green-800">{{ item.key }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  <script setup lang="ts">
  import { computed } from 'vue'
  import { ElButton } from 'element-plus'
  import type { ICameraData } from '@/apiFzn/types'
  
  const props = defineProps<{
    properties: object
    close(): void
  }>()
  const properties = computed(() => {
    return props.properties as ICameraData
  })
  const tableData = computed(() => {
    const res = [
      {
        key: '名称：',
        value: properties.value.name,
      },
    ]
    return res.filter((el) => el.value != undefined)
  })
  
  </script>
  